import React from 'react';
import { Helmet } from 'react-helmet-async';
import { siteSeo } from '../seo/seoUtils';

const SEO = ({
  title = siteSeo.name,
  description = siteSeo.description,
  keywords = siteSeo.keywords.join(', '),
  url = siteSeo.url,
  image = siteSeo.image,
  imageAlt = siteSeo.imageAlt,
  imageWidth = siteSeo.imageWidth,
  imageHeight = siteSeo.imageHeight,
  imageType = siteSeo.imageType,
  type = 'website',
  robots = 'index,follow,max-snippet:-1,max-image-preview:large,max-video-preview:-1',
  locale = siteSeo.locale,
  siteName = siteSeo.name,
  themeColor = '#000000',
  structuredData = null
}) => {
  const schemaBlocks = Array.isArray(structuredData)
    ? structuredData.filter(Boolean)
    : structuredData
      ? [structuredData]
      : [];

  return (
    <Helmet>
      <html lang="en" />
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="robots" content={robots} />
      <meta name="googlebot" content={robots} />
      <meta name="author" content={siteSeo.name} />
      <meta name="theme-color" content={themeColor} />
      <meta name="format-detection" content="telephone=no" />
      <link rel="canonical" href={url} />

      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:image:alt" content={imageAlt} />
      <meta property="og:image:width" content={String(imageWidth)} />
      <meta property="og:image:height" content={String(imageHeight)} />
      <meta property="og:image:type" content={imageType} />
      <meta property="og:locale" content={locale} />
      <meta property="og:site_name" content={siteName} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content={siteSeo.twitterHandle} />
      <meta name="twitter:creator" content={siteSeo.twitterHandle} />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:image:alt" content={imageAlt} />

      {schemaBlocks.map((schema, index) => (
        <script key={index} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
};

export default SEO;
